module.exports = __webpack_public_path__ + "static/media/promo.6fd8ce99.png";